$(document).ready(function() {
  $('.menu-drawer-container .header__icon--menu').click(function() {
    $('ul.menu-drawer__menu.list-menu li').first().find('details').attr('open', 'true');
  });
  
  $('.header__icon--search').click(function() {
    // $('.menu-drawer-container').removeClass('menu-opening');
    // $('body').removeClass('overflow-hidden-tablet');
    // setTimeout(function() {
    //   $('.menu-drawer-container').removeAttr('open');
    // }, 100);
    // $('.mobile-navigation-overlay').removeClass('visible');
    if($('.menu-drawer-container').attr('open') === undefined) {
       //$('.mobile-navigation-overlay').addClass('visible');
     }
     else {
       //$('.mobile-navigation-overlay').removeClass('visible');
       $('.menu-drawer-container .header__icon--menu').click();
       setTimeout(function() {
         $('.header__icon--search').click();
       }, 500);
     }
  });

  $('.menu-drawer-container summary.header__icon--menu').click(function() {
     if($('.menu-drawer-container').attr('open') === undefined) {
       $('.mobile-navigation-overlay').addClass('visible');
     }
     else {
       $('.mobile-navigation-overlay').removeClass('visible');
     }
  });

  $('.mobile-navigation-overlay').click(function() {
    /*$('.mobile-navigation-overlay').removeClass('visible');
    $('body').removeClass('overflow-hidden-tablet');
    $('.menu-drawer-container').removeClass('menu-opening');
    setTimeout(function() {
      $('.menu-drawer-container').removeAttr('open');
    }, 100);*/
    $('.menu-drawer-container .header__icon--menu').click();
  });
});